import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

import { TooltipProvider } from "@/components/ui/tooltip";

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <TooltipProvider delayDuration={150}>
      <div className="min-h-full bg-background text-foreground">
        <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="mx-auto flex max-w-7xl items-center px-6 py-3">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gradient-to-br from-rose-500 to-amber-500 text-background shadow-sm">
                <Activity className="h-4 w-4" strokeWidth={2.5} />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-sm font-semibold tracking-tight group-hover:text-foreground">
                  X Antisemitism Tracker
                </span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                  Daily monitoring dashboard
                </span>
              </div>
            </Link>
          </div>
        </header>
        <main className="mx-auto max-w-7xl px-6 py-8">{children}</main>
        <footer className="mx-auto max-w-7xl px-6 pb-10 pt-2 text-xs text-muted-foreground">
          Data sampled and classified daily. Estimates extrapolate from a
          random sample and carry sampling error.
        </footer>
      </div>
    </TooltipProvider>
  );
}
